import { IRegion } from '@/creditflowresearch/domain/vo/Filters/IRegion';
import { IProduct } from '@/creditflowresearch/domain/vo/Filters/IProduct';

export const prepareRegionsListForFilters = (regions: IRegion[], accessibleRegionsIds: string[]): IRegion[] => {
  return regions.map((region) => ({
    ...region,
    countryList: region.countryList.map((country) => ({
      ...country,
      canChangeResponse: country.canChangeResponse && accessibleRegionsIds.includes(region.regionId),
    })),
    canChangeResponse: region.canChangeResponse && accessibleRegionsIds.includes(region.regionId),
  }));
};

export const prepareProductsListForFilters = (products: IProduct[], accessibleProductsIds: string[]): IProduct[] => {
  return products.map((product) => ({
    ...product,
    canChangeResponse: product.canChangeResponse && accessibleProductsIds.includes(product.productId),
  }));
};
